import { apiRequest } from '@/utils/api-request';
import type {
  ArtifactListResponse,
  ListArtifactsParams,
} from '@/types/artifacts';

export async function listArtifacts(
  orgId: string,
  params: ListArtifactsParams = {},
): Promise<ArtifactListResponse> {
  const query = new URLSearchParams();
  if (params.scope) query.set('scope', params.scope);
  if (params.search) query.set('search', params.search);
  if (params.type) query.set('type', params.type);
  if (params.workflow_id) query.set('workflow_id', params.workflow_id);
  if (params.conversation_id)
    query.set('conversation_id', params.conversation_id);
  if (params.source_run_id) query.set('source_run_id', params.source_run_id);
  if (params.origin) query.set('origin', params.origin);
  if (params.sort) query.set('sort', params.sort);
  if (params.offset != null) query.set('offset', String(params.offset));
  if (params.limit != null) query.set('limit', String(params.limit));

  const qs = query.toString();
  const response = await apiRequest<ArtifactListResponse>({
    url: `/api/v1/orgs/${orgId}/artifacts${qs ? `?${qs}` : ''}`,
    method: 'GET',
    target: 'workflow',
  });

  if (response.detail) throw new Error(response.detail);
  if (!response.data) throw new Error('Failed to fetch artifacts');
  return response.data;
}
